import { Paper, Box, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';

// The shell every card of the dashboard is built in: an icon, a title, and the
// chart or table below it
function StatSection(props) {
    return (
        <Paper elevation={6} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <ListItem divider>
                <ListItemIcon> {props.icon} </ListItemIcon>
                <ListItemText
                    disableTypography
                    primary={<Typography variant='h6'> {props.title} </Typography>}
                    secondary={props.subtitle && <Typography variant='body2' color='textSecondary'> {props.subtitle} </Typography>}
                />
            </ListItem>
            <Box p={2} flexGrow={1} {...props.contentProps}>
                {props.children}
            </Box>
        </Paper>
    );
}

export default StatSection;
